import React from 'react';

import { ErrorArea, Form, Input, PasswordInput, Submit } from '@kodkafa/reform';

import { useLocation, useNavigate } from 'react-router-dom';
import { ReformSetError } from '@kodkafa/reform/dist/Form';
import { errorHandler } from '@/utils/error.handler';
import { clearEmptyProperties } from '@/utils/clear-empty-properties.util';
import { useTranslation } from 'react-i18next';
import { useAuthControllerRegisterMutation } from '@/store/services/MidleNestApi.service';
import WalletConnection from '@/components/shared/connections/Connections';
import { Divider } from '@/components';
import { useModal } from '@/hooks';
import { storageLocal } from '@/utils';

export default function RegisterComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [mutation] = useAuthControllerRegisterMutation();
  const { showModalByLink, hideModal } = useModal();
  const location = useLocation();
  // if Its is true, it is in the page view.
  const openInModalTrick = !location.pathname.match(/register/);

  const defaultValues = {
    name: '',
    username: '',
    email: '',
    phone: '',
    password: '',
    // ref: localStorage.getItem('ref') || undefined,
  };

  const handleSubmit = async ({ first, last, ...data }: any, setError: ReformSetError) => {
    const name = ''; //String(first).trim() + ' ' + String(last).trim();
    const ref = storageLocal.getItem('ref') || undefined;

    await mutation(clearEmptyProperties({ name, ref, ...data }))
      .unwrap()
      .then(() => {
        sessionStorage.setItem('email', data.email);
        sessionStorage.setItem('phone', data.phone);
        gtag('event', 'register', { identity: data.email });
        hideModal();
        navigate('/verify');
      })
      .catch((error) => errorHandler(error, setError));
  };

  return (
    <>
      <h2 className='mt-4 flex items-center justify-center space-x-8 font-bold md:text-xl'>
        <a
          onClick={showModalByLink}
          href='/login'
          data-modal={openInModalTrick}
          className='text-gray-500 dark:text-white cursor-pointer'
        >
          {t('Log In')}
        </a>
        <span className='text-gray-900 dark:text-[#FFDA68] cursor-pointer'>{t('Sign Up')}</span>
      </h2>
      <div className='text-sm mt-4 mb-6 text-center dark:text-white'>
        {t('Do you manage projects?')}{' '}
        <a
          className='text-blue-500 dark:text-blue-400 underline'
          href='https://customer.midle.io/register'
        >
          {t('Join us!')}
        </a>
      </div>

      <Divider className='mb-4 !text-sm text-gray-600 dark:text-white'>CONNECT WITH</Divider>
      <WalletConnection />
      <Divider className='mt-4 mb-2 dark:text-[#FFDA68]'>OR</Divider>
      <Form onSubmit={handleSubmit} defaultValues={defaultValues} className='flex !gap-4'>
        {/*<div>*/}
        {/*  <div className='flex gap-4'>*/}
        {/*    <div className=''>*/}
        {/*      <Input name='first' label='First Name' placeholder='Jon' className='w-full' />*/}
        {/*    </div>*/}
        {/*    <div className=''>*/}
        {/*      <Input name='last' label='Last Name' placeholder='Doe' className='w-full' />*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <ErrorArea name='name' />*/}
        {/*</div>*/}
        <div>
          <Input
            name='username'
            label='Username (Optional)'
            placeholder='Username'
            className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
          />
        </div>
        <div>
          <Input
            name='email'
            label='Email address'
            placeholder='jon@doe.com'
            className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
          />
        </div>
        {/*<div>*/}
        {/*  <Input name='phone' label='Phone number' placeholder='+44' className='w-full' />*/}
        {/*  <p className='mt-1 text-xs text-gray-500 text-right'>*/}
        {/*    {'We&apos;ll send a verification SMS.'}*/}
        {/*  </p>*/}
        {/*</div>*/}
        <div>
          <Input
            className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
            name='password'
            label='New Password'
            type='password'
            placeholder='new password'
          />
        </div>

        <div className='mt-2 text-xs dark:text-white'>
          <p className=' font-semibold'>{t('By signing up')}</p>

          <ul className='font-normal list-disc pl-4 mt-2 space-y-1'>
            <li>
              {t('You agree to the')}{' '}
              <a className='text-blue-500 dark:text-blue-400 underline' href='/tos' target='_blank'>
                {t('Terms of Service')},
              </a>{' '}
              <a
                className='text-blue-500 dark:text-blue-400 underline'
                href='/privacy'
                target='_blank'
              >
                {t('Privacy Policy')}.
              </a>{' '}
              and{' '}
              <a
                className='text-blue-500 dark:text-blue-400 underline'
                href='/cookies'
                target='_blank'
              >
                {t('Cookie Policy')}.
              </a>
            </li>
            <li>
              {t(
                'You agree that we are authorised to use your personal information to show you ads that are relevant to you to improve your user experience.',
              )}
            </li>
            <li>
              {t(
                'You agree that we are authorised to send you occasional emails about promotions, new features, products and important updates to keep you up.',
              )}
            </li>
            <li>
              {t('You can unsubscribe anytime. For more details, review our')}{' '}
              <a
                className='text-blue-500 dark:text-blue-400 underline'
                href='/privacy'
                target='_blank'
              >
                {t('Privacy Policy')}.
              </a>
            </li>
          </ul>
        </div>

        <ErrorArea />
        <div>
          <button
            type='submit'
            className='w-full text-sm font-semibold rounded-lg py-3 bg-blue-500 dark:bg-[#FFDA68] text-white dark:text-[#151515]'
          >
            {t('Register')}
          </button>
        </div>
      </Form>

      {/*<hr className='my-4 border-t' />*/}
      {/*<p className='text-center'>*/}
      {/*  Already have an account?{' '}*/}
      {/*  <Link to='/login' className='font-bold'>*/}
      {/*    Login*/}
      {/*  </Link>*/}
      {/*</p>*/}
    </>
  );
}
